import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OEPanelBaseModel } from "./oe-panel-base.model";
import { OENLockedState } from "../enums/oe-locked-state.enum";
import {
  ICTenorValueDateModel,
  ICAutocompleteGenericModel,
} from "../../interface/controls/models/bfx-interface-controls.models";
import { ICNInputControlState } from "../../interface/controls/models/bfx-interface-controls.enums";
import { OEPanelSpotModel } from "./oe-panel-spot.model";

export class OEPanelNdfModel extends OEPanelSpotModel {
  public fixingDate: any = {
    label: "Fixing Date",
    labelKey: "order_entry.panel.label.fixing_date",
    value: null,
    isEntrAllowed: true,
    disabled: true,
    externalState: null,
    minDate: new Date(),
    maxDate: new Date(),
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
  };

  public fixingSource: any = {
    label: "Fixing Code",
    labelKey: "order_entry.panel.label.fixing_source",
    value: null,
    dataset: [],
    disabled: false,
    state: null,
    lockState: OENLockedState.UNLOCKED,
    locked: false,
  };

  constructor() {
    super();

    // overwrite Spot valueDate from OEPanelSpotModel
    this.valueDate.value = new ICTenorValueDateModel(CubiqTS.Tenor.M1, null);
    this.valueDate.isSpot = false;
  }
}
